import React, { useState } from "react";
import './ads_card.css'
import { PiCellSignalMediumBold } from "react-icons/pi";
import { IoMdLink } from "react-icons/io";
import { LuUnlink } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { getRedirectionURL } from "../../../helpers/getPlatformName"
import { useDispatch } from "react-redux"
import { UPDATE_FILTER_DATA } from "../../../redux/features/user/filterSlice"
import { handleApi } from "../../../utils/authentication";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getPlatformName } from "../../../helpers/getPlatformName";





const AdsCard = ({
  handleConnect,
  isAccountLinked,
  platform,
  platform_icon,
  description,
  connecting,
  disabled,
  btn_icon,
  btn_title,
  accountDetails = {},
  social_media_type = "",
   fetchAdsAccountStatus=()=>{}
}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)

  const user = useSelector((state) => state?.user)

  const handleLinkingNavigation = (platform_id, media_type) => {
    try {


      if (media_type === 'organic_social') {

        dispatch(UPDATE_FILTER_DATA({
          select_organic_social_platform: {
            platform_id: platform_id,
            platform_name: getPlatformName(platform_id)
          }
        }))
        // dispatch(UPDATE_FILTER_DATA({select_organic_social_platform:{platform_id:platform_id,social_media_type:media_type,accountDetails}}))
      }

      else {
        dispatch(UPDATE_FILTER_DATA({ filter_ads_selected_platform: { platform_id: platform_id, social_media_type: media_type, accountDetails } }))
      }



      navigate(getRedirectionURL(platform_id, media_type))



    } catch (e) {
      console.log(e)
    }
  }

  const disconnectAccount = async () => {
    try {
      setLoading(true)
      let formData = new FormData();
      if (accountDetails?.is_posts_connected && social_media_type == "organic_social") {
        formData.append('is_posts_connected', accountDetails?.is_posts_connected)
      
      }
      if (accountDetails?.is_ads_connected && social_media_type == "paid_social") {
        formData.append('is_ads_connected', accountDetails?.is_ads_connected)
      }
      formData.append('platform_id', accountDetails?.platform_id)
      formData.append('client_id', user?.client_id)

      let result = await handleApi('disconnect_social_media_account', "POST", {}, formData)
      if (result?.success) {
        toast.success("Account disconnected successfully")
        fetchAdsAccountStatus()
      }


    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }




  return (
    <>
      <div
        className={`p-4 d-flex flex-column gap-4  w-100 h-100  
         custom-card position-relative`}
      >
        <div className="d-flex flex-row gap-6 justify-content-between">
          <div className="d-flex flex-column">
            {/* <i className="bi bi-google"></i> */}
            <img
              src={platform_icon}
              alt=""
              style={{ width: "2rem", height: "2rem", borderRadius: "50%" }}
            />
            <span className="fw-bold">{platform}</span>
          </div>
          <div>
            {isAccountLinked ? (
              <span className="text-success">
                Account Linked <i className="bi bi-check-circle"></i>
              </span>
            ) : (
              <button
                className="btn btn-md rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center connect_button"
                onClick={() => handleConnect()}
                disabled={disabled || connecting}
              >
                {btn_icon ? btn_icon : <i className="bi bi-plug "></i>}

                {connecting ? "Connecting..." : (btn_title ? btn_title : "Connect")}
              </button>
            )}
          </div>
        </div>

        <div>
          <span>{description}</span>
        </div>
        {/* {isAccountLinked && (
          <button
            onClick={handleShowUnAssociatedCampaigns}
            className="btn btn-md rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center"
            disabled={loadingUnAssociatedCampaigns}
          >
            {loadingUnAssociatedCampaigns ? (
              <span className="">Fetching Campaigns...</span>
            ) : (
              <span className="">Show Unassociated Campaigns</span>
            )}
          </button>
        )} */}
        {isAccountLinked ?
          <div className="connection_container">
            <div className="connection_card">
              <div className="connection_card_heading">
                <span>Connected as</span>
                <span>Connected on</span>
              </div>
              <div className="connection_card_status">
                <span>{accountDetails?.account_details?.account_name ?? ''}</span>
                <span>{accountDetails?.account_details?.created_at ?? ''}</span>
              </div>
              <hr />
              <div className="connection_card_post_status">
                <div className="connection_card_post_status_count">
                  <PiCellSignalMediumBold className="icon" />
                  {social_media_type === 'organic_social' &&
                    <span>{accountDetails?.total_posts_linked ?? 0} Posts Linked</span>}
                  {social_media_type === 'paid_social' &&
                    <span>{accountDetails?.total_ads_linked ?? 0} Ads Linked</span>}
                </div>
                <div className="connection_card_post_status_badge">
                  <span>{social_media_type === 'organic_social' && 'Posts'} {social_media_type === 'paid_social' && 'Ads'} {social_media_type === 'owned_media' && 'Analytics'}</span>
                </div>
              </div>

            </div>
            <div className="btn_container">
              <div className="d-flex align-items-center gap-1">
                {social_media_type === 'organic_social' && <button className="link_posts_btn" onClick={() => handleLinkingNavigation(accountDetails?.platform_id, social_media_type)}>
                  <IoMdLink className="icon" />
                  <span>Link Posts</span>
                </button>}

                {social_media_type === 'paid_social' && <button className="link_ads_btn" onClick={() => handleLinkingNavigation(accountDetails?.platform_id, social_media_type)}>
                  <IoMdLink className="icon" />
                  <span>Link Ads</span>
                </button>}

                {social_media_type === 'owned_media' && <button className="link_ads_btn" onClick={() => handleLinkingNavigation(accountDetails?.platform_id, social_media_type)}>
                  <IoMdLink className="icon" />
                  <span>Track Website Analytics</span>
                </button>}
              </div>

              <button className="disconnect_account_btn" disabled={loading} onClick={() => disconnectAccount()}>
                <LuUnlink className="icon" />
                <span> {loading ? "Loading...." : "Disconnect"} </span>
              </button>
            </div>

          </div> : null}

      </div>
    </>
  );
};

export default AdsCard;
